import React from "react";
import { AuthData } from "app/utils/auth";

export const AuthContext = React.createContext<AuthData | null>(null);

export function useAuthContext(): AuthData | null {
  return React.useContext(AuthContext);
}
